import React from 'react';
import { Box, Container, Typography, Stack, Button } from '@mui/material';
import { FaFacebook } from 'react-icons/fa';

export default function FollowUsSection() {
  return (
    <Box sx={{ bgcolor: '#F2F2F2', py: 6 }}>
      <Container>
        <Typography variant="h5" align="center" gutterBottom>
          Stay Connected
        </Typography>
        <Typography variant="body1" align="center" sx={{ mb: 4 }}>
          Follow us on Facebook for the latest updates, insights and behind-the-scenes.
        </Typography>
        <Stack direction="row" justifyContent="center">
          <Button
            variant="contained"
            startIcon={<FaFacebook />}
            href="https://www.facebook.com/Lemda.webdevelopment"
            target="_blank"
            sx={{ textTransform: 'none' }}
          >
            Follow on Facebook
          </Button>
        </Stack>
      </Container>
    </Box>
  );
}
